import React, { useEffect } from "react";
import { useNavigate, useLocation, Outlet } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import './styles/AdminDashboard.css';

const Admin = () => {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (location.pathname === "/admin") {
      navigate("/admin/dashboard");
    }
  }, [location.pathname, navigate]);

  /*
  const handleBack = () => {
    const pathSegments = location.pathname.split("/").filter(Boolean); // Remove empty segments
    
    if (pathSegments.length === 2) {
      // If it's directly under "/admin", go to dashboard
      navigate("/admin/dashboard");
    } else {
      // Otherwise, go back one step
      navigate(-1);
    }
  };
  */

  const handleBack = () => {
    navigate("/admin/dashboard");
  };

  const showBackButton = 
    location.pathname !== "/admin/dashboard" &&
    !location.pathname.includes("/add") &&
    !location.pathname.includes("/edit");

  return (
    <div className="adminWrapper">
      <Helmet>
        <title>Admin - Website Name</title>
        <meta name="robots" content="noindex, nofollow" />
      </Helmet>

      {showBackButton && (
        <div className="admin-back-wrapper">
          <button className="admin-back-button" onClick={handleBack} aria-label="Go back to previous page">
            ⬅️ Back
          </button>
        </div>
      )}

      <Outlet />
    </div>
  );
};

export default Admin;